import { z } from "zod";

export const loginSchema = z.object({
  name: z.string().min(1, "Username inválido"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});

export type LoginSchema = z.infer<typeof loginSchema>;